import { makeStyles } from 'makeStyles';
import { LIST_HOVER, LIST_SELECTED, LIST_SELECTED_TEXT } from 'theme/colors';

export const useStyles = makeStyles()((theme) => ({
  selector: {
    background: theme.palette.background.paper,
    height: 40,
    padding: '9px 1px 8px 13px',
    border: 'solid 1px #dadce0',
    borderRadius: 3,
    display: 'flex',
    alignItems: 'center',
    '& .MuiSelect-outlined': {
      fontSize: 15,
      fontWeight: 'normal',
      letterSpacing: 'normal',
      textAlign: 'left',
    },
  },
  selectorPaper: {
    border: `solid 1px ${theme.palette.grey['200']}`,
    boxShadow: '0 10px 25px 0 rgba(0, 0, 0, 0.12)',
    backgroundColor: '#fff',
  },
  selectorList: {
    padding: '12px 0 12px 0',
    '& .Mui-selected': {
      backgroundColor: `${LIST_SELECTED}`,
      color: `${LIST_SELECTED_TEXT}`,
      '&:hover': {
        backgroundColor: `${LIST_HOVER}`,
      },
    },
    '& .MuiListItem-button': {
      padding: '6px 18px',
      '&:hover': {
        backgroundColor: `${LIST_HOVER}`,
      },
    },
    '& .MuiMenuItem-root': {
      fontSize: '15px',
    },
  },
}));
